import React, { Component } from 'react';
import styled from 'styled-components';
import { extend, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import moment from "moment";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import CommentIcon from '@material-ui/icons/Comment';
import AttachmentIcon from '@material-ui/icons/AttachFile';
import { PdfViewerMode } from '@loanbossinc/pdf-viewer';
import { CardPageLayout } from 'component-lib/CardPageLayout';
import DrawerAttachments from 'modals/DrawerAttachments/DrawerAttachments';
import { DrawerNotes } from 'modals/DrawerNotes/DrawerNotes';
import AddSummaryModal from 'modals/AddSummaryModal';
import { SimpleInfoModal } from 'modals/SimpleInfoModal';
import { PrimaryButton, ButtonSizeOptions, SecondaryButton, DEAL_METRICS, COMPANY_LEVELS, LabeledButtonWithCountMultiple, ButtonText, LOAN_STATUSES, GUEST_PERMISSIONS } from '@loanbossinc/component-library';
import {
	loanDetailGetLoan, updateLoanDetails, loanDetailGetDealMetrics,
	loanPostAttachment, loanPutAttachment, loanDeleteAttachment, loanGetAttachments,
	loanAddReference, loanPostNote, loanPutNote, loanDeleteNote, loanGetNotes, updateFieldSummary,
	deleteLoan, loanGetReferenceFields, loanUpdateReferences, loanDeleteReference, downloadLoan
} from './loanDetail.store';
import { mapCompanySelector, mapGuestPermissions } from 'store/state/auth';
import { getConfigItemByParentId } from 'store/state/configItems';
import { BORROWER_LIST_OF_DOCUMENTS, GUARANTOR_LIST_OF_DOCUMENTS, CASHMANAGEMENT_LIST_OF_DOCUMENTS } from '../../components/Admin/ConfigItems/FinancialReporting/constants';
import { LOAN_SECTION_KEYS } from './loan.constants';
import { LoanSummary } from './loan-summary/loanSummary';
import { LoanEconomics } from './loan-economics/';
import { LoanPrepaymentDetails } from './loan-prepayment/loan-prepayment-details';
import { LoanPrepaymentSchedule } from './loan-prepayment-schedule/loan-prepayment-schedule';
import { LoanExtensions } from './loan-extensions/loan-extensions';
import { FinancialReporting } from './financial-reporting';
import { LoanFinancialReporting } from './loan-financial-reporting/loan-financial-reporting';
import { LoanAdvancesAndReserves } from './loan-advances-and-reserves/loan-advances-and-reserves';
import { LoanCovenantsAndOther } from './loan-covenants-and-other/loan-covenants-and-other';
import { LoanInsurance } from './loan-insurance/loan-insurance';
import { LoanGuaranty } from './loan-guaranty/loan-guaranty';
import { LoanPartialRelease } from './loan-partial-release/loan-partial-release';
import { LoanHedgeRequirements } from './loan-hedge-requirements/loan-hedge-requirements';
import { LoanClosingCosts } from './loan-closing-cost/loan-closing-costs';
import { LoanMisc } from './loan-misc/loan-misc';
import { LoanForbearance } from './loan-forbearance/loan-forbearance';
import { LoanAssumptions } from './loan-assumptions/loan-assumptions';
import { LoanGuarantor } from './loan-guarantor/loan-guarantor';
import { GenericHeroCard } from "component-lib/";
import { LoanQuoteHistory } from './loan-quote-history/loan-quote-history';
import { LoanPropertyAllocation } from './loan-property-allocations/loan-property-allocations';
import UploadSpreadsheetModal from 'modals/UploadSpreadsheetModal/uploadSpreadsheetModal';
import { isContainedInList } from 'helpers/row-logic-helper';
import guestPermissionHelper from 'utils/guestPermissionHelper';
import pagesHelper from 'utils/pagesHelper';
import ReferenceDrawer from 'modals/ReferenceDrawer/ReferenceDrawer';
import { ToastInfo, ToastError } from '../../components/Global/Toasts/Toasty';
import { modifyValuesForSerialization } from './loanDetailEditUtil';
import featureFlags from "constants/featureFlags";

const dealMetrics = [
	DEAL_METRICS.CLOSING_DATE
	, DEAL_METRICS.PURCHASE_PRICE
	, DEAL_METRICS.SQUARE_FEET
];

const StyledLeftChildContainer = styled.div`
display: flex;
flex-direction: row;
width: 100%;
`;


const StyledButtonText = styled(ButtonText)`
&& {
  display: flex;
  flex: 2;
  width: 100%;
  justify-content: flex-start;
  margin-top: 16px;
  .label {
    margin-left: 14px;
  }

  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  color: #005AA9;

  font-size: 14px;
  background-color: #00000;
  text-transform: none;

  .align-right {
    display: flex;
    margin-left: auto;
  }

  &.reverse > span > span.material-icons {
    transform: rotate(270deg);
    margin: 0;
  }
}
`;

const StyledDownloadButton = styled(ButtonText)`&&&{
  margin-right:24px;

  background: #FFFFFF;
  /* Stroke / LB Blue */
  
  border: 1px solid #005AA9;
  box-sizing: border-box;
  border-radius: 4px;
  .MuiButton-label{
    flex-direction: row-reverse;
  }
  .material-icons{
    margin-left: 0;
    margin-right: .2em;
  }
  .label{
    margin-right: 5px;
  }
}`;

const StyledBodyWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;

const StyledTitleSection = styled.div`
  && {
    display: flex;
    flex-direction: row;

    .title {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      align-items: center;
      text-align: center;
  
      color: #000000;
    }
  }
`;
const StyledLabeledButtonWithCountMultiple = styled(LabeledButtonWithCountMultiple)`
  margin-top: 2em;
`;
const LOAN_MODAL_ATTACHMENTS = 'LOAN_MODAL_ATTACHMENTS';
const LOAN_MODAL_NOTES = 'LOAN_MODAL_NOTES';
const UPLOAD_SPREADSHEET = 'UPLOAD_SPREADSHEET';
const ADD_SUMMARY = 'ADD_SUMMARY';
const SIMPLE_INFO_MODAL = 'SIMPLE_INFO_MODAL';

class LoanDetail extends Component {
	state = {
		isAllExpanded: false
		, isAllCollapsed: false
		, openModal: { name: null, data: null }
		, heroCardButtons: []
		, uploadSpreadsheetModalOpen: false
		, pdfViewer: { open: false }
		, hide: true
		, confirmationModal: {
			title: "",
			onClose: () => { },
			onAccept: () => { },
			content: "",
			referenceMode: true
		}
	}

	componentDidMount() {
		this.props.loanGetReferenceFields();
		const { loanId } = this.props.match.params;

		this.props.loanDetailGetLoan({ loanId });
		this.props.loanDetailGetDealMetrics({ loanId, dealMetrics });
		this.props.loanGetNotes({ loanId });
		this.props.loanGetAttachments({ modelName: 'loan', modelId: loanId });
		this.props.getConfigItemByParentId({ id: BORROWER_LIST_OF_DOCUMENTS, refresh: true });
        this.props.getConfigItemByParentId({ id: GUARANTOR_LIST_OF_DOCUMENTS, refresh: true });
        this.props.getConfigItemByParentId({ id: CASHMANAGEMENT_LIST_OF_DOCUMENTS, refresh: true });
	}

	componentDidUpdate(prevProps) {
		if (this.props !== prevProps) {
			this.setHeroCardButtons();
		}
	}

	adminLoanUploadButton = () => {

		const { authentication } = this.props;
		if (!authentication || !authentication.isSystemAdmin) return null;

		return { label: "Admin Upload", onClick: () => this.openModal(UPLOAD_SPREADSHEET) };
	}

	deleteLoanButton = () => {
		const { authentication } = this.props;
		const { loanId } = this.props.match.params;
		if (!authentication || authentication.isGuest || !authentication.isSystemAdmin) return null;

		return {
			label: "Delete Loan",
			onClick: () => {
				this.openConfirmationDialog("Delete Loan", this.closeModal, () => {
					if (loanId) {
						this.props.deleteLoan({ loanId: loanId, callback: () => this.props.history.push(`/deal/${this.props.loan.details.dealId}`) });
					}
					this.closeModal();
				},
					(<><p>Are you sure that you want to delete this loan?</p> <p>This action cannot be undone.</p></>)
				);
			}
		};
	
	}
	componentLockedButton = () => {
		return this.openConfirmationDialog("Feature Locked", null, () => {this.closeModal(); }, (<p>This feature is locked for editing</p>));
	}

	openConfirmationDialog = (title, onClose, onAccept, content) => {
		this.setState({ confirmationModal: { title, onClose, onAccept, content } });
		this.openModal(SIMPLE_INFO_MODAL);
	}

	setHeroCardButtons = () => {
		let buttons = [];

		const adminLoanUploadButton = this.adminLoanUploadButton();
		if (adminLoanUploadButton) buttons.push(adminLoanUploadButton);

		const deleteLoanButton = this.deleteLoanButton();
		if (deleteLoanButton) buttons.push(deleteLoanButton);

		this.setState({ heroCardButtons: buttons });
	};

	getNotificationOptions = () => {
		const { notes, attachments, company, authentication } = this.props;
		const isStarter = company.companyLevelId !== COMPANY_LEVELS.PROFESSIONAL
			&& company.companyLevelId !== COMPANY_LEVELS.ENTERPRISE
			&& company.companyLevelId !== COMPANY_LEVELS.SECONDARY_SPONSOR;

		let { notesLength, attachmentsLength } = pagesHelper.getNotesAttachmentCounts(notes, attachments, authentication);

		const buttonList = [{
			label: 'notes'
			, count: notesLength
			, onClick: () => this.openModal(LOAN_MODAL_NOTES)
			, icon: <CommentIcon />
			, buttonWidth: "179px"
		}, {
			label: 'ATTACHMENTS'
			, count: attachmentsLength
			, onClick: () => this.handleOpenAttachments(null)
			, icon: <AttachmentIcon />
			, buttonWidth: "179px"
		}];

		isStarter ? buttonList.splice(2, 1) : buttonList.splice(3, 1);
		return buttonList;
	}

	openModal = (name, data = null) => this.setState({ openModal: { name, data } });
	closeModal = () => this.setState({ openModal: { name: null, data: null } });
	isModalOpen = (modalName) => {
		const { openModal } = this.state;
		return openModal.name === modalName;
	}

	scrollUp = () => {
		document.getElementById('ScrollToNav').scrollIntoView({ behavior: 'smooth' });
	}

  onBackButtonClick = () => {
    this.props.history.push(`/deal/${this.props.loan.details.dealId}`);
  }

	renderHeroCard = () => {
		const { loan } = this.props;
		const year = loan.details.closingDate ? moment(loan.details.closingDate).format("YYYY") : "";
		const title = `${loan.details["lenderCompany.name"]} ${year}`;
		return (
			<div>
				<GenericHeroCard {...{ ...this.props,
																	loan,
																	deal: loan.details.deal,
																	buttons: this.state.heroCardButtons,
																	title: title,
																	backLabel: "Deal Summary",
																	onBackButtonClick: this.onBackButtonClick,
																	displayMetrics: true,
																	hideBackButton: true }} />

				<StyledLabeledButtonWithCountMultiple options={this.getNotificationOptions()} />
				<StyledLeftChildContainer>
					<StyledButtonText
						label="Back to top"
						iconName="arrow_forward"
						reverse={true}
						alignRight={false}
						key={1}
						onClick={() => this.scrollUp()}
					/>
				</StyledLeftChildContainer>
			</div>
		);
	}

	isPaidOff = (loan) => {
		return isContainedInList(loan, 'details.loanStatusId', [
			LOAN_STATUSES.PAID_OFF
		]);
	}
	editSummary = (field, summaryText) => {
		this.setState({
			summaryText: summaryText,
			summaryField: field
		});
		this.openModal(ADD_SUMMARY);
	}

	updateReferences = (references) => {
		const { loanId } = this.props.match.params;
		this.props.loanUpdateReferences({ references, modelName: "loan", modelId: loanId });
	};

	deleteRef = (reference, callback) => {
		if (reference.id) {
			this.openConfirmationDialog("Delete Reference", this.closeModal, () => {
				this.props.loanDeleteReference({ reference, callback });
				this.closeModal();
			},
				(<><p>Are you sure that you want to delete this reference?</p> <p>This action cannot be undone.</p></>)
			);
		} else {
			this.openConfirmationDialog("Delete Reference", this.closeModal, () => {
				this.closeModal();
			},
				(<><p>Please refresh your browser and try again.</p></>)
			);
		}
	};

	validatePropertyAllocation = (loan) => {
		let totalAllocationPercentage = 0;

		if (loan.properties && loan.properties.length > 0) {
			totalAllocationPercentage += loan.properties.reduce((accum, property) => {
				if (!property) return accum;
				accum += (property.allocationPercent * 1) / 100;
				return accum;
			}, 0);
		}
		if (totalAllocationPercentage > 1) {
			ToastError("Allocation is greater than 100% across all properties");
			return false;
		}

		return true;
	};

	shouldskipCashflowUpdate = () => {
		const { sectionName } = this.props.match.params;
		switch (sectionName) {
			case LOAN_SECTION_KEYS.FINANCIAL_COVENANTS:
			case LOAN_SECTION_KEYS.DEFINITIONS:
			case LOAN_SECTION_KEYS.FINANCIAL_REPORTING_GENERAL:
				return true;

			case LOAN_SECTION_KEYS.SECTION_ADDITIONAL_ADVANCES:
			case LOAN_SECTION_KEYS.SECTION_ESCROW_RESERVE:
			case LOAN_SECTION_KEYS.CLOSING_COSTS:
			case LOAN_SECTION_KEYS.CASH_MANAGEMENT:
			case LOAN_SECTION_KEYS.FINANCIAL_CASH_MANAGEMENT:
			case LOAN_SECTION_KEYS.LEASING:
			case LOAN_SECTION_KEYS.GENERAL_INFORMATION:
			case LOAN_SECTION_KEYS.AMORTIZATION:
			case LOAN_SECTION_KEYS.EXTENSIONS:
			case LOAN_SECTION_KEYS.FINANCIAL_REPORTING:
			case LOAN_SECTION_KEYS.BORROWERDOCS:
			case LOAN_SECTION_KEYS.GUARANTORDOCS:
			case LOAN_SECTION_KEYS.FINANCIALMISCELLANEOUS:
			case LOAN_SECTION_KEYS.GUARANTY:
			case LOAN_SECTION_KEYS.HEDGE_REQUIREMENTS:
			case LOAN_SECTION_KEYS.INSURANCE:
			case LOAN_SECTION_KEYS.MISCELLANEOUS:
			case LOAN_SECTION_KEYS.PARTIAL_RELEASE:
			case LOAN_SECTION_KEYS.PROPERTY_ALLOCATIONS:
			default:
				return false;
		}
	}

	onSubmit = (loan, callback) => {
		if (loan && this.validatePropertyAllocation(loan)) {
			const id = loan.details.id;
			const loanDetailsRequest = {};
			const skipCashflowUpdate = this.shouldskipCashflowUpdate();
			if (!id) {
				loanDetailsRequest.isNew = true;
			} else {
				loanDetailsRequest.id = id;
				loanDetailsRequest.isNew = false;
				const clonedValues = cloneDeep(loan);
				loanDetailsRequest.loanDetails = modifyValuesForSerialization(clonedValues);
				loanDetailsRequest.loanDetails.skipCashflowUpdate = skipCashflowUpdate;
				loanDetailsRequest.callback = callback || (() => this.props.loanDetailGetLoan({ loanId: id }));
				ToastInfo("Saving... Please wait")
				this.props.updateLoanDetails(loanDetailsRequest);
			}
		}
	}

	isEditButtonEnabled(authentication, guestPermission) {
		if (this.props.flags[featureFlags.ZEP34_HIDE_LOAN_GI_AMORT_DETAIL_EDIT]) {
			// Edit controls are visible to system admins even when the flag disables their visibility
			return authentication.isSystemAdmin;
		}

		return guestPermissionHelper.enableEditButton(authentication, guestPermission, GUEST_PERMISSIONS.EDIT);
	}

	renderBody = () => {
		const { loan, history, authentication, guestPermission } = this.props;
		const { loanId } = this.props.match.params;
		const { isAllExpanded, isAllCollapsed } = this.state;
		const { bar971HideOldFinancialReportingSection, bar2599ReportingSectionOnLoanDetailsPage } = this.props.flags;

		if (loan.extensions && loan.extensions.length > 0)
			loan.extensions = loan.extensions.filter(x => x.id !== "new")

		const groupProps = {
			data: loan,
			authentication,
			loanId,
			dealId: loan.details.dealId,
			history,
			shouldExpandAll: isAllExpanded,
			onToggleExpandAll: () => this.setState({ isAllExpanded: false }),
			shouldCollapseAll: isAllCollapsed,
			onToggleCollapseAll: () => this.setState({ isAllCollapsed: false }),
			enableEditButton: guestPermissionHelper.enableEditButton(authentication, guestPermission, GUEST_PERMISSIONS.EDIT),
			modifySummaryText: guestPermissionHelper.enableEditButton(authentication, guestPermission, GUEST_PERMISSIONS.EDIT) ? this.editSummary : this.componentLockedButton,
			eventHandlers: { onOpenReferenceDrawer: this.handleOpenReferenceDrawer, onOpenAttachmentDrawer: this.handleOpenAttachments },
			markAsComplete: this.onSubmit,
		};
		return (
			<StyledBodyWrapper>
				{!bar2599ReportingSectionOnLoanDetailsPage && (
					<>
						<div>
							<StyledDownloadButton
								className={"pdf-button"}
								label={"PDF"}
								onClick={() => this.props.downloadLoan({ loanId })}
								iconName={"file_download"} />
						</div>
						<StyledTitleSection>
							<div className="title">Loan Details</div>
							<SecondaryButton
								style={{ marginLeft: 'auto' }}
								label="Collapse All"
								onClick={() => this.setState({ isAllCollapsed: true })}
								size={ButtonSizeOptions.smFluid}
							/>
							<PrimaryButton
								style={{ marginLeft: 24 }}
								label="Expand All"
								onClick={() => this.setState({ isAllExpanded: true })}
								size={ButtonSizeOptions.smFluid}
							/>
						</StyledTitleSection>

						{!this.isPaidOff(loan) && <LoanSummary {...groupProps} />}
						<LoanEconomics {...groupProps} enableEditButton={this.isEditButtonEnabled(authentication, guestPermission)} />
						<LoanPrepaymentDetails {...groupProps} />
						<LoanPrepaymentSchedule {...groupProps} />
						<LoanAssumptions {...groupProps} />
						<LoanExtensions {...groupProps} />
						{!bar971HideOldFinancialReportingSection && <LoanFinancialReporting {...groupProps} />}
						<FinancialReporting {...groupProps} />
						<LoanCovenantsAndOther {...groupProps} />
						<LoanAdvancesAndReserves {...groupProps} />
						<LoanInsurance {...groupProps} />
						<LoanGuarantor {...groupProps} />
						<LoanGuaranty {...groupProps} />
						<LoanPartialRelease {...groupProps} />
						<LoanPropertyAllocation {...groupProps} />
						<LoanHedgeRequirements {...groupProps} />
						<LoanClosingCosts {...groupProps} />
						<LoanMisc {...groupProps} />
						<LoanQuoteHistory {...groupProps} />
						<LoanForbearance {...groupProps} />
					</>
				)}
				{bar2599ReportingSectionOnLoanDetailsPage && (
					<FinancialReporting {...groupProps} />
				)}
			</StyledBodyWrapper>
		);
	}

	handleOpenReferenceDrawer = referencedFieldPath => {
		this.setState({
			referenceCurrentFile: null,
			pdfViewer: extend(this.state.pdfViewer, {
				open: true,
				referencedFieldPath
			})
		});
	};

	handleOpenPdfForReference = file => {
		this.closeModal(LOAN_MODAL_ATTACHMENTS);
    this.setState({ pdfViewer: extend(this.state.pdfViewer, {
			open: true
		}), referenceCurrentFile: file });
	};
	
	handleOpenAttachments = referencedFieldPath => {
    this.setState({ pdfViewer: extend(this.state.pdfViewer, {open: false, referencedFieldPath}), referenceMode: true});
		this.openModal(LOAN_MODAL_ATTACHMENTS);
  };

	handleOpenViewOnlyAttachments = () => {
		this.setState({pdfViewer: extend(this.state.pdfViewer, {open: false, referencedFieldPath: null}), referenceMode: false});
		this.openModal(LOAN_MODAL_ATTACHMENTS);
	};

	// attachment drawer control
	handleReferenceDrawerClose = () => {
		this.setState({ pdfViewer: extend(this.state.pdfViewer, { open: false }) });
	};

	handleReferenceDrawerBack = referencedFieldPath => {
		this.handleOpenAttachments(referencedFieldPath);
	};

	render() {
		const { loan, isLoading } = this.props;
		const { loanId } = this.props.match.params;
		if (!loan) return null;

		return (
			<>
				<CardPageLayout {...this.props}
					isReversed
					bannerImageUrl={loan && loan.details && loan.details.deal && loan.details.deal.imageLarge}
					cardComponent={this.renderHeroCard()}
					bodyComponent={this.renderBody()}
				/>
				<DrawerAttachments
					flags={this.props.flags}
					referenceMode={this.state.referenceMode}
					isOpen={this.isModalOpen(LOAN_MODAL_ATTACHMENTS)}
					files={this.props.attachments}
					authentication={this.props.authentication}
					closeDrawer={this.closeModal}
					isLoading={isLoading}
					onAdd={(file) => this.props.loanPostAttachment({ file, loanId })}
					onUpdate={(file) => this.props.loanPutAttachment({ file, loanId })}
					onRemove={(file) => this.props.loanDeleteAttachment({ fileId: file.id, loanId })}
					onOpenPdfForReference={(file) => this.handleOpenPdfForReference(file)}
					references={this.props.loan.references}
					referencedFieldPath={this.state.pdfViewer.referencedFieldPath}
					referenceFields={this.props.referenceFields}
				/>
				<ReferenceDrawer
					flags={this.props.flags}
					open={this.state.pdfViewer.open}
					mode={PdfViewerMode.Editable}
					modelId={loanId}
					currentFile={this.state.referenceCurrentFile}
					referencedFieldPath={this.state.pdfViewer.referencedFieldPath}
					references={this.props.loan.references}
					referenceFields={this.props.referenceFields}
					onAddReference={this.props.loanAddReference}
					onRemoveReference={this.deleteRef}
					onClose={this.handleReferenceDrawerClose}
					onBack={this.handleReferenceDrawerBack}
					onBackLabel="Attachments"
					onUpdateReferences={this.updateReferences}
					canDelete={!this.props.authentication.isGuest}
				/>

				<DrawerNotes
					isOpen={this.isModalOpen(LOAN_MODAL_NOTES)}
					notes={this.props.notes}
					authentication={this.props.authentication}
					closeDrawer={this.closeModal}
					onAdd={(note) => this.props.loanPostNote({ note, loanId })}
					onUpdate={(note) => this.props.loanPutNote({ note, loanId })}
					onRemove={(note) => this.props.loanDeleteNote({ noteId: note.id, loanId })}
					type="loan"
				/>

				<UploadSpreadsheetModal
					isOpen={this.isModalOpen(UPLOAD_SPREADSHEET)}
					onClose={() => {
						this.closeModal();
						this.props.loanDetailGetLoan({ loanId });
					}}
					loanId={loanId} />

				<AddSummaryModal
					isOpen={this.isModalOpen(ADD_SUMMARY)}
					onClose={this.closeModal}
					onSave={(field, value) => { this.props.updateFieldSummary({ loanId, field, value, callback: () => this.props.loanDetailGetLoan({ loanId }) }) }}
					summaryText={this.state.summaryText}
					field={this.state.summaryField}
				/>

				<SimpleInfoModal
					title={this.state.confirmationModal.title}
					isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
					onClose={this.state.confirmationModal.onClose ? () => this.state.confirmationModal.onClose() : null}
					onAccept={() => this.state.confirmationModal.onAccept()}
					content={this.state.confirmationModal.content}
				/>
			</>
		);
	}
}

const mapStateToProps = ({ newLoanDetail, loading, authentication, configItems }) => ({
	...newLoanDetail
	, guestPermission: mapGuestPermissions(authentication, newLoanDetail.guestPermission)
	, company: mapCompanySelector(authentication)
	, authentication
	, isLoading: loading.loan_file_upload
	, listOfDocuments: configItems.configItemByParent
});

export default compose(
	withRouter
	, withLDConsumer()
	, connect(mapStateToProps, {
		loanDetailGetLoan
		, loanDetailGetDealMetrics
		, loanGetAttachments
		, loanPostAttachment
		, loanPutAttachment
		, loanDeleteAttachment
		, loanGetNotes
		, loanPostNote
		, loanPutNote
		, loanDeleteNote
		, updateFieldSummary
		, deleteLoan
		, loanGetReferenceFields
		, loanAddReference
		, loanUpdateReferences
		, loanDeleteReference
		, updateLoanDetails
		, downloadLoan
		, getConfigItemByParentId
	})
)(LoanDetail);
